<template>
  <div id="Error">
        <div class="info">
            <strong>서비스에 접속할 수 없습니다.</strong>
            <p>
                앱에서만 서비스에 접속할 수 있습니다.<br/>
                이용에 불편을 드려서 죄송합니다.
            </p>
        </div>

        <div class="btnWrap">
            <button type="button" class="red" @click="moveAppDownload">앱 다운로드</button>
        </div>
        
    </div>
</template>
<script>
export default {
  data() {
    return {
    };
  },
  methods: {
    moveAppDownload() {
      this.$router.push({ name: "download" }).catch(function() {});
    },
  },
};
</script>